import { ICognitoStorage } from 'amazon-cognito-identity-js';
import {
  get as capacitorStorageGet,
  remove as capacitorStorageRemove,
} from 'modules/capacitor-storage';

import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';
import { noCircularLogger } from 'utils/logger/no-circular-logger';

// there is no secure storage on web, so we use localStorage
export const secureAuthStorage: ICognitoStorage = localStorage;

const LEGACY_USER_ID_KEY = 'RBI::USER_AUTH_TOKEN';

/** migrate userid to sync storage to be consistent with native */
export const TEMP_migrateAuthKeys = (): void => {
  try {
    if (syncStorage.getBoolean(SyncStorageKey.HAS_MIGRATED_FROM_CAPACITOR_STORAGE)) {
      return;
    }

    const userId = capacitorStorageGet(LEGACY_USER_ID_KEY).value as string;
    if (userId) {
      syncStorage.setString(SyncStorageKey.USER_ID, userId);
    }
    capacitorStorageRemove(LEGACY_USER_ID_KEY);

    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('CognitoIdentityServiceProvider')) {
        let value = localStorage.getItem(key);
        if (value.startsWith('"') && value.endsWith('"')) {
          value = value.slice(1, -1);
        }
        if (value) {
          localStorage.setItem(key, value);
        }
      }
    });
    syncStorage.setBoolean(SyncStorageKey.HAS_MIGRATED_FROM_CAPACITOR_STORAGE, true);

    noCircularLogger('info', {
      message: 'TEMP_migrateAuthKeys completed',
    });
  } catch (error) {
    noCircularLogger('error', {
      message: 'TEMP_migrateAuthKeys failed, user will be logged out',
      error,
    });
  }
};
